import type { StyleSpecification } from 'maplibre-gl'

export const ECUADOR_CENTER: [number, number] = [-78.5, -1.5]
export const ECUADOR_INITIAL_ZOOM = 5.4

const osmRasterStyle: StyleSpecification = {
  version: 8,
  sources: {
    osm: {
      type: 'raster',
      tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
      tileSize: 256,
      attribution: '© OpenStreetMap contributors',
    },
  },
  layers: [
    {
      id: 'osm',
      type: 'raster',
      source: 'osm',
    },
  ],
}

export function getMapStyle(): string | StyleSpecification {
  const styleUrl = import.meta.env.VITE_MAP_STYLE_URL

  if (styleUrl) return styleUrl

  if (import.meta.env.DEV) {
    return osmRasterStyle
  }

  throw new Error(
    'VITE_MAP_STYLE_URL es obligatorio en producción. ' +
      'El fallback público de OpenStreetMap se usa solo para desarrollo.',
  )
}
